import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { consumeAppleState } from "config/apple";

/**
 * ★ 2026-11-04 애플 웹 로그인 콜백 (/appleAuth) — NaverCallback 과 같은 구조.
 *  - 애플은 #id_token=…&code=…&state=… (fragment) 로 돌려준다. state 가 우리가 보낸 값이 아니면 거절(CSRF).
 *  - 취소하면 #error=user_cancelled_authorize 로 돌아온다 → 로그인 화면으로.
 *  - id_token 을 iOS 네이티브와 같은 /auth/apple 로 보낸다(서버가 애플 공개키로 검증).
 */
const AppleCallback = () => {
  const navigate = useNavigate();
  const { appleLogin } = useAuth();
  const [msg, setMsg] = useState("애플 로그인 처리 중…");
  const once = useRef(false); // StrictMode 이중 실행 방지

  useEffect(() => {
    if (once.current) return;
    once.current = true;

    const hash = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
    // 토큰이 주소창·기록에 남지 않게 바로 지운다.
    try { window.history.replaceState(null, "", window.location.pathname); } catch { /* 무시 */ }
    const idToken = hash.get("id_token");
    const error = hash.get("error");
    const redirect = consumeAppleState(hash.get("state"));

    if (error || !idToken) {
      setMsg("애플 로그인이 취소됐어요.");
      setTimeout(() => navigate("/login", { replace: true }), 1200);
      return;
    }
    if (!redirect) {
      setMsg("로그인 요청이 만료됐어요. 다시 시도해 주세요.");
      setTimeout(() => navigate("/login", { replace: true }), 1500);
      return;
    }

    (async () => {
      try {
        const result = await appleLogin({ identityToken: idToken });
        if (result?.isNew) {
          navigate(`/social-signup?redirect=${encodeURIComponent(redirect)}`, { replace: true });
        } else {
          navigate(decodeURIComponent(redirect), { replace: true });
        }
      } catch (err) {
        setMsg(err?.response?.data?.message || "애플 로그인에 실패했어요.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      <div
        className="page"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}
      >
        <p className="t-16-single">{msg}</p>
      </div>
    </div>
  );
};

export default AppleCallback;
